import React, { FC, useEffect, useState, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import DHDialog from '../dh-dialog/dh-dialog.component';
import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';

type ConfirmDialogProps = {
    handleClose: () => void;
    open: boolean;
    dialogTitle?: string;
    dialogContent?: ReactNode;
    confirmBtnLabel?: string;
    declineBtnLabel?: string;
    handleConfirm: () => void;
};

const ConfirmDialog: FC<ConfirmDialogProps> = ({
    handleClose,
    open,
    handleConfirm,
    dialogTitle,
    dialogContent,
    confirmBtnLabel,
    declineBtnLabel,
}: ConfirmDialogProps) => {
    const { t: translate } = useTranslation(['common']);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(false);
    }, [open]);

    const handleConfirmClick = () => {
        setIsLoading(true);
        handleConfirm();
    };

    return (
        <DHDialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={handleClose}
            title={dialogTitle || translate('common:ARE_YOU_SURE')}
            actions={
                <>
                    {declineBtnLabel && (
                        <Button onClick={handleClose} data-test="confirm-dialog.decline-btn">
                            {declineBtnLabel}
                        </Button>
                    )}
                    <LoadingButton
                        variant="contained"
                        onClick={handleConfirmClick}
                        autoFocus
                        loading={isLoading}
                        data-test="confirm-dialog.confirm-btn"
                    >
                        {confirmBtnLabel || translate('common:YES')}
                    </LoadingButton>
                </>
            }
        >
            {dialogContent ? dialogContent : undefined}
        </DHDialog>
    );
};

export default ConfirmDialog;
